module.exports = __webpack_public_path__ + "static/img/gywm_banner.105a69db.png";